// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3qXm1","rootCenter":"LoadMoreObserver_rootCenter__b5UIQ","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__12EkU"};